<section class="main-section">
    <!-- Header Section -->
    <div class="header-section">
        <div class="header-left-side">
            Import Attendance
        </div>
        <div class="header-right-side">
            <img src="./../../../../../../assets/images/close.svg" alt="close_svg" (click)="closeBtn()"/>
        </div>
    </div>

    <!-- File Upload Section -->
    <div class="upload-container">
        <div class="drag-drop-area" 
            (dragover)="onDragOver($event)" 
            (drop)="onFileDrop($event)"
            *ngIf="!uploadComplete; else previewSection">
            <div>Drag a valid .xlsx file here to import </div>
            <div style="color: gray;">or, click to browse</div>
            <input type="file" id="fileInput" (change)="onFileSelect($event)" hidden />
            
            <!-- Only show Select files button when no file is selected -->
            <button class="upload-btn" 
                    (click)="openFileInput()" 
                    *ngIf="!selectedFile">
                Select files
            </button>
            
            <!-- Upload progress section -->
            <div class="upload-progress" *ngIf="isUploading">
                <mat-progress-bar mode="determinate" [value]="uploadProgress"></mat-progress-bar>
                <div class="progress-info">
                    <span>Uploading: {{ uploadProgress }}%</span>
                    <mat-spinner diameter="20" *ngIf="uploadProgress < 100"></mat-spinner>
                </div>
            </div>
            
            <!-- File info display -->
            <div class="file-info" *ngIf="selectedFile && !isUploading">
                <div class="file-name">{{ selectedFile.name }}</div>
                <div class="file-size">{{ formatFileSize(selectedFile.size) }}</div>
                <mat-icon class="remove-file" (click)="removeFile()">cancel</mat-icon>
            </div>
        </div>

        <!-- Preview section after upload -->
        <ng-template #previewSection>
            <div class="preview-container">
                <div class="preview-header">
                    <mat-icon>check_circle</mat-icon>
                    <span>File uploaded successfully</span>
                </div>
                <div class="preview-content">
                    <div class="file-preview">
                        <mat-icon class="file-icon">description</mat-icon>
                        <div class="file-details">
                            <div class="file-name">{{ selectedFile?.name }}</div>
                            <div class="file-size">{{ formatFileSize(selectedFile?.size) }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    </div>

    <!-- Button Section -->
    <div class="button-section">
        <div class="left-side">
            <div class="cancel-button" (click)="closeBtn()">
                {{ uploadComplete ? 'Close' : 'Cancel' }}
            </div>
        </div>
        <div class="right-side">
            <button class="apply-button" 
                    [disabled]="!selectedFile || isUploading" 
                    (click)="importAttendance()"
                    *ngIf="!uploadComplete">
                Import Attendance
            </button>
        </div>
    </div>
</section>